import toast, { ToastOptions } from 'react-hot-toast'

export class NotifyService {
  static error(e: any, options?: ToastOptions) {
    toast.error(e.response?.data?.Message || e?.message || e, options)
  }

  static success(r: any, options?: ToastOptions) {
    toast.success(r?.data?.Message || r, options)
  }
}
